import { useAtom } from "jotai";
import { productCacheTimestampAtom } from "../../stores/productCacheTimestamp/productCacheTimestamp.store";

export function useProductCacheTimestamp() {
  const productCacheTimestamp = useAtom(productCacheTimestampAtom);

  return productCacheTimestamp;
}
